function addNameSpaces(className, nameSpaces) {
  return nameSpaces.filter(function (x) {
    return x;
  }).map(function (ns) {
    return "".concat(className, "--").concat(ns);
  }).join(' ');
}
export default function modifyClassnames(classNames) {
  for (var _len = arguments.length, nameSpaces = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    nameSpaces[_key - 1] = arguments[_key];
  }
  return classNames.split(' ').map(function (cls) {
    return "".concat(cls, " ").concat(addNameSpaces(cls, nameSpaces));
  }).filter(function (val, i, src) {
    return src.indexOf(val) === i;
  }).join(' ');
}